<script lang="ts">
    import type { Setting } from "..";
    import { createSettingFilter } from "../createFilter";
    import { linkHandling } from "../link";
    import { onMount } from "svelte";

    export let setting: Setting;

    const {
        prefix,
        suffix
    } = setting;

    const filter = createSettingFilter(setting);

    let elem: HTMLElement;

    function focus() {
      elem.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
      elem.setAttribute("data-search", "included");
    }

    onMount(() => {
      linkHandling.settingsCallbacks[setting.id] = focus;
      return () => linkHandling.settingsCallbacks[setting.id] = undefined;
    });
</script>

<!----------------------------------------------------------------------------->

<label bind:this={elem} use:filter for={setting.id}>
  {#if prefix}
    <span class="prefix">{prefix}</span>
  {/if}

  <div>
    {#if suffix}
        <slot />
        <span class="suffix">{suffix}</span>
    {:else}
      <slot />
    {/if}
    <slot name="reset"/>
  </div>
</label>

<!----------------------------------------------------------------------------->

<style>
    label {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: span 2;
        padding-block: 0.125rem;
        min-height: 2rem;
        box-sizing: content-box;
        align-items: center;
        width: max-content;
        justify-self: left;
        user-select: none;
    }

    .prefix {
        grid-column: 1;
        padding-left: 0.5rem;
    }

    div {
        padding-inline: 0.5rem;
        grid-column: 1 / 2;
        width: max-content;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.75ch;
    }

    .prefix + div {
        grid-column: 2;
    }
</style>
